import React, { useEffect } from "react";

import Machine from "./Machine";
import ConfigureNew from "./Machine/ConfigureNew";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  updateTaskStatus,
  fetchVMsListStart,
  showNotificationWithTimeout
} from "store/actions";

function Machines(props) {
  return (
    <div class="virtual_main_section text_overflow">
      <div class="virtual_list virtual_off  online computer_machine ">
        <div class="li_wrapper">
          <div class="virtual_li_top">
            {Object.keys(props.vmsList).map(val => (
              <React.Fragment key={val}>
                {props.vmsList[val].status !== 8 && (
                  <Machine key={val} {...props.vmsList[val]}></Machine>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showNotificationWithTimeout,
      updateTaskStatus,
      fetchVMsListStart
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Machines);
